module.exports = __webpack_public_path__ + "media/images/faces/male/40-c4d14dc8f3f810b98fdf3eede1a04d3d.jpg";